'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('parking_requirements', {
      url: '/account/parking/parking_requirements',
      template: '<parking-requirements></parking-requirements>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/parking/parking_requirements/parking_requirements.routes.js